<template>
  <div >
    <p class="text-center mb-0">
      <button
        type="button"
        class="btn btn-link font-14 p-t-0-i"
        data-toggle="collapse"
        data-target="#cost-breakdown"
        aria-expanded="false"
        aria-controls="cost-breakdown"
        @click="expanded = !expanded"
      >
        Details
        <i
          class="fa"
          :class="{ 'fa-caret-up': expanded, 'fa-caret-down': !expanded }"
        ></i>
      </button>
    </p>
    <div class="collapse" id="cost-breakdown">
      <div class="well">
        <div class="row" v-if="fake || paymentProcessingFee">
          <div class="col-1"></div>
          <div class="col-6 text-right">Credit Card Surcharge :</div>
          <div class="col-3 text-right text-bold" v-if="!fake">
            ${{ paymentProcessingFee.toFixed(2) }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div class="row">
          <div class="col-1"></div>
          <div class="col-6 text-right">Gross Base Premium :</div>
          <div class="col-3 text-right text-bold" v-if="!fake">
            ${{
              parseFloat(
                typeof summaryData.grossPremiumExCharges !== "undefined" &&
                  summaryData.grossPremiumExCharges
                  ? summaryData.grossPremiumExCharges
                  : 0
              ).toFixed(2)
            }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div class="row">
          <div class="col-1"></div>
          <div class="col-6 text-right">Gross Base Premium GST :</div>
          <div class="col-3 text-right text-bold" v-if="!fake">
            ${{
              parseFloat(
                summaryData.grossPremiumExChargesTotalGst !== "undefined" &&
                  summaryData.grossPremiumExChargesTotalGst
                  ? summaryData.grossPremiumExChargesTotalGst
                  : 0
              ).toFixed(2)
            }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div
          class="row"
          v-if="
            fake ||
            (summaryData.stampDuty !== null &&
              summaryData.stampDuty !== undefined)
          "
        >
         <div class="col-1"></div>
          <div
            class="col-6 text-right"
            :class="{ 'strike-through': isExemptFromStampDuty && !fake }"
          >
            Stamp Duty :
          </div>
          <div
            class="col-3 text-right text-bold"
            :class="{ 'strike-through': isExemptFromStampDuty }"
            v-if="!fake"
          >
            ${{
              parseFloat(
                summaryData.stampDuty !== "undefined" && summaryData.stampDuty
                  ? summaryData.stampDuty
                  : 0
              ).toFixed(2)
            }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div class="row">
          <div class="col-1"></div>
          <div class="col-6 text-right">Service Charge Fee :</div>
          <div class="col-3 text-right text-bold" v-if="!fake">
            ${{
              parseFloat(
                summaryData.serviceChargeFee !== "undefined" &&
                  summaryData.serviceChargeFee
                  ? summaryData.serviceChargeFee
                  : 0
              ).toFixed(2)
            }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div class="row">
          <div class="col-1"></div>
          <div class="col-6 text-right">Service Charge Fee GST :</div>
          <div class="col-3 text-right text-bold" v-if="!fake">
            ${{
              parseFloat(
                summaryData.serviceChargeFeeGst !== "undefined" &&
                  summaryData.serviceChargeFeeGst
                  ? summaryData.serviceChargeFeeGst
                  : 0
              ).toFixed(2)
            }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div class="row" v-if="accidentCover || fake">
          <div class="col-1"></div>
          <div class="col-6 text-right">Accident Cover :</div>
          <div class="col-3 text-right text-bold" v-if="!fake">
            ${{ accidentCover.price }}
          </div>
          <div class="col-3 text-right text-bold" v-else>$0.00</div>
        </div>

        <div class="row" v-if="summaryData.discount">
          <div class="col-1"></div>
          <div class="col-6 text-right">Discount :</div>
          <div class="col-3 text-right text-bold">
            - ${{ summaryData.discount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import * as appConfigs from "../configs";

export default {
  props: ["fake", "currentStep"],
  data() {
    return {
      expanded: false,
    };
  },

  computed: {
    ...mapState({
      summaryData: (state) => state.summaryData,
      accidentCover: (state) => state.accidentCover,
      usingCreditCard: (state) => state.usingCreditCard,
      step: (state) => state.step,
    }),

    ...mapGetters(["isExemptFromStampDuty"]),

    paymentProcessingFee() {
      var total = this.summaryData.totalPrice;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }

      if (this.step == 5 && this.usingCreditCard) {
        return this.calculateCreditCardSurcharge(total) - total;
      }

      return false;
    },
  },

  methods: {
    calculateCreditCardSurcharge(totalCostOfInsurance) {
      // Charge = ( Pgoal + Sfixed) / (1 - Spercent)
      return (
        (totalCostOfInsurance + appConfigs.stripeFixedSurcharge) /
        (1 - appConfigs.stripePercentageSurcharge)
      );
    },
  },
};
</script>

<style lang="scss">
.font-14 {
  font-size: 14px;
}
.btn-link {
  border: none !important;
  color: #2fa9ff !important;
  font-weight: normal;
  background: transparent !important;
  text-decoration: none !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
@media screen and (max-width: 320px) {
  #cost-breakdown {
    .well {
      font-size: 12px;
    }
  }
}
.strike-through {
  text-decoration: line-through;
}

</style>
